import { SUM } from '__jsLibs/EXCEL';

const gettersMonthlyrevenue = {
	TotalRevenues(state) {
		return SUM([
			+state.result['unit_1_rent'],
			+state.result['unit_2_rent'],
			+state.result['unit_3_rent'],
			+state.result['unit_4_rent'],
			+state.result['other_revenue']
		]);
	}
};

export { gettersMonthlyrevenue };
